// Version : 0.0.1
// Author : AGALYA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:01-08-2025
/* eslint-disable import/no-anonymous-default-export */
import FunderActionTypes from './funder.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	addFunderDetailsResponse: null,
	getFunderListResponse: null,
	getFunderListArr: [],
	fetchFunderDetailsResponse: null,
	fetchFunderDetailsArr: [],
	deleteFunderDetailsResponse: null,
	updateIsPublishFunder: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD FUNDER DETAILS START *********************** */
		case FunderActionTypes.ADD_FUNDER_SUCCESS:
			return { ...state, addFunderDetailsResponse: action.payload };

		/** ***************** ADD FUNDER DETAILS FAILURE *********************** */
		case FunderActionTypes.ADD_FUNDER_FAILURE:
			return { ...state, addFunderDetailsResponse: action.payload };

		/** ***************** ADD FUNDER DETAILS RESPONSE_CHANGED *********************** */
		case FunderActionTypes.ADD_FUNDER_RESPONSE_CHANGED:
			return { ...state, addFunderDetailsResponse: null };
		/** ***************** ADD FUNDER DETAILS END *********************** */

		/** ***************** UPDATE FUNDER DETAILS START *********************** */
		case FunderActionTypes.UPDATE_FUNDER_SUCCESS:
			return { ...state, updateFunderDetailsResponse: action.payload };

		/** ***************** UPDATE FUNDER DETAILS FAILURE *********************** */
		case FunderActionTypes.UPDATE_FUNDER_FAILURE:
			return { ...state, updateFunderDetailsResponse: action.payload };

		/** ***************** UPDATE FUNDER DETAILS RESPONSE CHANGED *********************** */	
		case FunderActionTypes.UPDATE_FUNDER_RESPONSE_CHANGED:
			return { ...state, updateFunderDetailsResponse: null };
		/** ***************** UPDATE FUNDER DETAILS END *********************** */

		/** ***************** GET FUNDER LIST START *********************** */
		case FunderActionTypes.GET_FUNDER_LIST_SUCCESS:
			return {
				...state,
				getFunderListResponse: action.payload,
				getFunderListArr: docodeHexResponse(action.payload, 'GetFunderListKey'),
			};

		/** ***************** GET FUNDER LIST FAILURE *********************** */
		case FunderActionTypes.GET_FUNDER_LIST_FAILURE:
			return { ...state, getFunderListResponse: action.payload, getFunderListArr: [] };

		/** ***************** GET FUNDER LIST RESPONSE_CHANGED *********************** */
		case FunderActionTypes.GET_FUNDER_LIST_RESPONSE_CHANGED:
			return { ...state, getFunderListResponse: null };
		/** ***************** GET FUNDER LIST END *********************** */

		/** ***************** FETCH FUNDER DETAILS START *********************** */
		case FunderActionTypes.FETCH_FUNDER_SUCCESS:
			return {
				...state,
				fetchFunderDetailsResponse: action.payload,
				fetchFunderDetailsArr: docodeHexResponse(action.payload, 'FetchFunderDetailsKey'),
			};

		/** ***************** FETCH FUNDER DETAILS FAILURE *********************** */
		case FunderActionTypes.FETCH_FUNDER_FAILURE:
			return { ...state, fetchFunderDetailsResponse: action.payload };

		/** ***************** FETCH FUNDER DETAILS RESPONSE CHANGED *********************** */
		case FunderActionTypes.FETCH_FUNDER_RESPONSE_CHANGED:
			return { ...state, fetchFunderDetailsResponse: null, fetchFunderDetailsArr: [] };
		/** ***************** FETCH FUNDER DETAILS END *********************** */

		/** ***************** DELETE FUNDER DETAILS START *********************** */
		case FunderActionTypes.DELETE_FUNDER_SUCCESS:
			return { ...state, deleteFunderDetailsResponse: action.payload };

		/** ***************** DELETE FUNDER DETAILS FAILURE *********************** */
		case FunderActionTypes.DELETE_FUNDER_FAILURE:
			return { ...state, deleteFunderDetailsResponse: action.payload };

		/** ***************** DELETE FUNDER DETAILS RESPONSE CHANGED *********************** */
		case FunderActionTypes.DELETE_FUNDER_RESPONSE_CHANGED:
			return { ...state, deleteFunderDetailsResponse: null };
		/** ***************** DELETE FUNDER DETAILS END *********************** */

		/** ***************** UPDATE IS PUBLISH FUNDER START *********************** */
		case FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_SUCCESS:
			return { ...state, updateIsPublishFunder: action.payload };

		/** ***************** UPDATE IS PUBLISH FUNDER FAILURE *********************** */
		case FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_FAILURE:
			return { ...state, updateIsPublishFunder: action.payload };

		/** ***************** UPDATE IS PUBLISH FUNDER RESPONSE CHANGED *********************** */
		case FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_RESPONSE_CHANGED:
			return { ...state, updateIsPublishFunder: null };
		/** ***************** UPDATE IS PUBLISH FUNDER END *********************** */

		default:
			return state;
	}
};
